import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCategoryById, searchEntries } from "@/hooks/useSiteData";

export default function SearchBox() {
  const [keyword, setKeyword] = useState("");
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const boxRef = useRef<HTMLDivElement>(null);

  const results = keyword.trim() ? searchEntries(keyword).slice(0, 5) : [];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (boxRef.current && !boxRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const goToEntry = (id: string) => {
    setOpen(false);
    setKeyword("");
    navigate(`/entry/${id}`);
  };

  return (
    <div ref={boxRef} className="relative w-full">
      <form
        className="flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2 transition-colors focus-within:border-primary-400"
        onSubmit={(event) => {
          event.preventDefault();
          if (results[0]) {
            goToEntry(results[0].id);
          } else if (keyword.trim()) {
            setOpen(true);
          }
        }}
      >
        <i className="ri-search-line text-foreground-400"></i>
        <input
          type="text"
          value={keyword}
          onChange={(event) => {
            setKeyword(event.target.value);
            setOpen(true);
          }}
          onFocus={() => setOpen(true)}
          placeholder="搜索人物 / 标签 / 话题"
          aria-label="站内搜索词条"
          className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
        />
        {keyword && (
          <button
            type="button"
            aria-label="清空搜索"
            onClick={() => setKeyword("")}
            className="cursor-pointer text-foreground-400 transition-colors hover:text-foreground-700"
          >
            <i className="ri-close-line"></i>
          </button>
        )}
      </form>

      {open && keyword.trim() && (
        <div className="absolute left-0 right-0 top-full z-50 mt-2 overflow-hidden rounded-md border border-background-200 bg-background-50 shadow-sm">
          {results.length > 0 ? (
            <ul className="divide-y divide-background-100">
              {results.map((item) => (
                <li key={item.id}>
                  <button
                    type="button"
                    onClick={() => goToEntry(item.id)}
                    className="flex w-full cursor-pointer items-center gap-3 px-3 py-2.5 text-left transition-colors hover:bg-primary-50"
                  >
                    <img
                      src={item.avatar}
                      alt={`${item.name} 头像`}
                      title={`${item.name} 词条`}
                      className="h-8 w-8 shrink-0 rounded-full object-cover"
                    />
                    <span className="min-w-0">
                      <span className="block truncate text-sm text-foreground-900">{item.title}</span>
                      <span className="block truncate text-xs text-foreground-500">
                        {getCategoryById(item.categoryId)?.name} · {item.status}
                      </span>
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p className="px-3 py-4 text-center text-sm text-foreground-500">
              没有找到相关词条，试试其他关键词
            </p>
          )}
        </div>
      )}
    </div>
  );
}